import React, { useContext } from 'react'
// Components
import CTAButton from 'components/utils/Button/CTAButton'
import UIColumnFilter from 'components/utils/Filter/ColumnFilter'
// Styles
import { LockIcon, CheckIcon, EllipsisHIcon } from 'styles/fontAwesome'
// Additional
import { Tab } from 'static/tabs'
import { AccordionContext } from 'components/utils/Accordion/Accordion.context'
import { Routing } from 'helpers/routing'
import { TournamentStageRecord } from 'data/TournamentStageRecord'
import { RecordSetting } from 'components/utils/Table/_Table.settings'

export module Settings {
  export const get = (
    tournamentId?: string,
    options?: {
      disableNew?: boolean
      hide?: {
        tournament?: boolean
      }
    }
  ): RecordSetting<TournamentStageRecord> => {
    return [
      {
        accessor: 'id',
        className: 'table-hidden',
      },
      {
        accessor: 'isFrozen',
        className: 'table-lock',
        Header: function HeaderContent({ row }: any) {
          return <LockIcon />
        },
        Cell: function CellContent({ row }: any) {
          return <>{row.values.isFrozen && <LockIcon />}</>
        },
      },
      {
        accessor: 'tournament_id',
        className: 'table-hidden',
        Filter: function FilterContent(p: any) {
          return <UIColumnFilter from={Tab.Stages} filter={p} />
        },
        filter: 'fuzzyText',
      },
      {
        accessor: 'tournament_name',
        Header: 'Tournament',
        className: options?.hide?.tournament
          ? 'table-hidden'
          : 'table-tournament-name',
      },
      {
        accessor: 'order_number',
        Header: 'Order',
        className: 'table-order',
      },
      {
        accessor: 'name',
        Header: 'Name',
        className: 'table-name',
      },
      {
        accessor: 'isApproved',
        Header: 'Approved',
        className: 'table-approved',
        Cell: function CellContent({ row }: any) {
          return <>{row.values.isApproved && <CheckIcon />}</>
        },
      },
      {
        id: 'ctaButton',
        className: 'table-cta-button',
        sticky: 'right',
        Header: function HeaderContent({ row }: any) {
          const { toggle } = useContext(AccordionContext)

          if (options?.disableNew) return <></>

          return (
            <CTAButton onClick={toggle}>
              <EllipsisHIcon />
            </CTAButton>
          )
        },
        Cell: function CellContent({ row }: any) {
          return (
            <CTAButton
              path={Routing.getStageDetailUrl({
                tournament: tournamentId ?? Routing.NewRecordSymbol,
                stage: row.values.id,
              })}
            >
              {row.values.isFrozen ? 'View' : 'Edit'}
            </CTAButton>
          )
        },
      },
    ]
  }
}
